import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert, Card, CardBody, CardTitle, Col, Form, FormFeedback, Input, Label, Modal, ModalBody, ModalHeader, Row, UncontrolledTooltip } from 'reactstrap';
import Flatpickr from "react-flatpickr";
import * as Yup from "yup";
import { useFormik } from 'formik';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import miniral from "../../../assets/images/svg/miniral.svg";
import { numberWithCommas } from "../../../helpers/globalHelper"
import TableContainer from 'Components/Common/TableContainer';
import DeleteModal from 'Components/Common/DeleteModal';
import Spinners from "Components/Common/Spinner";

import { useWorkReportCreateMutation, useWorkReportDeleteMutation, useWorkReportFindAllQuery, useWorkReportFindOneQuery, useWorkReportUpdateMutation } from 'store/apis/core/workReportApi';
import { useOrgFindAllQuery, useCommonDataFindAllQuery, useDocumentFindAllQuery } from 'store';
import DocumentsUpload from 'Components/fileUpload/DocumentsUpload';
import Lightbox from 'react-image-lightbox';


const Detail = () => {
  const [customQuery, setCustomQuery] = useState<any>();
  const [workReportCount, setWorkReportCount] = useState<any>();
  const [workReportList, setWorkReportList] = useState<any>();
  const [customPagination, setCustomPagination] = useState<any>();
  const [customPageSize, setCustomPageSize] = useState<any>();
  const [customPageLength, setCustomPageLength] = useState<any>();
  const [workReportModalViewBackdrop, setWorkReportModalViewBackdrop] = useState(false)
  const [selectedFiles, setSelectedFiles] = useState<any>([])
  const [resetFiles, setResetFiles] = useState<any>([])
  const [isLoading, setLoading] = useState<any>(true);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [workReportUptOne, setWorkReportUptOne] = useState<any>(null)
  const [workReportDataOne, setWorkReportDataOne] = useState<any>(null)
  const [orgASelected, setOrgASelected] = useState<any>(null)
  const [orgBSelected, setOrgBSelected] = useState<any>(null)
  const [cmdTypeSelected, setCmdTypeSelected] = useState<any>(null)
  const [deleteModal, setDeleteModal] = useState<any>(null);

  const [documentList, setDocumentList] = useState<any>([]);
  const [imageZoom, setImageZoom] = useState<any>([]);
  const [photoIndex, setphotoIndex] = useState<number>(0);
  const [isGalleryZoom, setisGalleryZoom] = useState<boolean>(false);

  const [workReportCreate, workReportCreateResult] = useWorkReportCreateMutation();
  const [workReportUpdate, workReportUpdateResult] = useWorkReportUpdateMutation();
  const [workReportDelete, workReportDeleteResult] = useWorkReportDeleteMutation();

  const {
    data:
    findOnedata,
    error } = useWorkReportFindOneQuery(workReportDataOne?.id);

  const {
    data: orgaAId,
    error: orgaAIdError,
    isFetching: orgaAIdFetching,
  } = useOrgFindAllQuery();


  const {
    data: orgaBId,
    error: orgaBIdError,
    isFetching: orgaBIdFetching,
  } = useOrgFindAllQuery();


  const {
    data: cmd_work_type,
    error: cmd_work_typeError,
    isFetching: cmd_work_typeFetching,
  } = useCommonDataFindAllQuery('?group_name=cmd_work_type');


  const {
    data: workReportData,
    error: workReportError,
    isFetching: isWorkReportFetching,
  } = useWorkReportFindAllQuery(customQuery);
  const {
    data: documentFiles,
    error: documentFilesError,
    isFetching: isDocumentFilesFetching,
  } = useDocumentFindAllQuery(`?table_name=work_report&connection_id=${workReportDataOne?.id}`);

  useEffect(() => {
    setDocumentList(documentFiles?.data)
    documentList?.forEach((item) => {
      if (item?.type_name === 'image') {
        setImageZoom(item.fileUrl);
      }
    });

    const imageUrls = documentList
      ?.filter((item) => item?.type_name === 'image')
      ?.map((item) => item.fileUrl);

    setImageZoom(imageUrls || []);


  }, [documentList, documentFiles])

  useEffect(() => {
    setWorkReportDataOne(findOnedata?.data)

  }, [findOnedata])

  useEffect(() => {
    setOrgASelected(orgaAId?.data)
  }, [orgaAId])

  useEffect(() => {
    setOrgBSelected(orgaBId?.data)
  }, [orgaBId])

  useEffect(() => {
    setCmdTypeSelected(cmd_work_type?.data)
  }, [cmd_work_type])


  useEffect(() => {
    setLoading(false)
    setWorkReportList(workReportData?.data)
    setWorkReportCount(workReportList?.length)
    setCustomPagination(workReportData?.pagination);
    const tempQuery = `?page=${customPageLength !== undefined ? customPageLength : 1} &pageSize=${customPageSize !== undefined ? customPageSize : 25}`;
    setCustomQuery(tempQuery)
    console.log('==workReportData==', workReportData)
  }, [workReportData, customQuery])

  const onClickDelete = (workReportRowData) => {
    setWorkReportDataOne(workReportRowData);
    setDeleteModal(true);
  };

  const handleDeleteWorkReport = () => {
    if (workReportDataOne) {
      workReportDelete(workReportDataOne.id);
      setDeleteModal(false);
    }
  }

  const [modal_backdrop, setmodal_backdrop] = useState(false);

  const handleEditClick = useCallback((arg: any) => {
    const workReportTemp = arg;
    setWorkReportUptOne({
      id: workReportTemp.id,
      cmd_work_type: workReportTemp.cmd_work_type,
      name_work_type: workReportTemp.name_work_type,
      work_name: workReportTemp.work_name,
      a_organization_id: workReportTemp.a_organization_id,
      b_organization_id: workReportTemp.b_organization_id,
      work_number: workReportTemp.work_number,
      work_budget: workReportTemp.work_budget,
      date: workReportTemp.date,
    });
    setIsEdit(true);
    toggle();
  }, []);

  const handleViewClick = (workReportRowData) => {
    setWorkReportDataOne(workReportRowData);
    workReportModal_backdrop();
  };

  const handleAddClick = () => {
    setIsEdit(false);
    toggle();
    setWorkReportDataOne(null);
    setWorkReportUptOne(null);
  };

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: workReportUptOne?.id,
      cmd_work_type: workReportUptOne?.cmd_work_type,
      work_name: workReportUptOne?.work_name,
      a_organization_id: workReportUptOne?.a_organization_id,
      b_organization_id: workReportUptOne?.b_organization_id,
      work_number: workReportUptOne?.work_number,
      work_budget: workReportUptOne?.work_budget,
      date: workReportUptOne?.date,
    },
    validationSchema: Yup.object({
      work_name: Yup.string().typeError("Текст төрлийн утга оруулна уу !").required("Утга оруулна уу"),
      date: Yup.date().typeError("Огноо төрлийн оруулна уу !").required("Утга оруулна уу"),
      work_number: Yup.number().typeError("Тоон төрлийн утга сонгоно уу!").required("Утга оруулна уу"),
    }),

    onSubmit: (values: any) => {
      if (isEdit) {
        const formData = new FormData();
        formData.append('id', workReportUptOne ? workReportUptOne.id.toString() : '0');
        formData.append('cmd_work_type', values?.cmd_work_type);
        formData.append('work_name', values?.work_name);
        formData.append('a_organization_id', values?.a_organization_id);
        formData.append('b_organization_id', values?.b_organization_id);
        formData.append('work_number', values?.work_number);
        formData.append('work_budget', values?.work_budget);
        formData.append('date', values?.date);
        workReportUpdate(formData)
          .unwrap()
          .then((response) => {
            toastr.success("Мэдээлэл амжилттай засагдлаа!", "Амжилттай");
          })
          .catch((error) => {
            toastr.error("Мэдээлэл амжилтгүй!", "Амжилтгүй");
          })
      } else {
        const formData = new FormData();
        formData.append('cmd_work_type', values['cmd_work_type'] || '');
        formData.append('work_name', values['work_name'] || '');
        formData.append('a_organization_id', values['a_organization_id'] || '');
        formData.append('b_organization_id', values['b_organization_id'] || '');
        formData.append('work_number', values['work_number'] || 0);
        formData.append('work_budget', values['work_budget'] || '');
        formData.append('date', values['date'] || '');
        workReportCreate(formData)
          .unwrap()
          .then((response) => {
            toastr.success("Мэдээлэл амжилттай үүслээ!", "Амжилттай");
          })
          .catch((error) => {
            toastr.error("Мэдээлэл амжилтгүй!", "Амжилтгүй");
          })
      }
      validation.resetForm();
      setmodal_backdrop(false)
      toggle();
    }
  });

  function removeBodyCss() {
    document.body.classList.add("no_padding");
  }
  function workReportModal_backdrop() {
    setWorkReportModalViewBackdrop(!workReportModalViewBackdrop);
    removeBodyCss();
  }

  const toggle = useCallback(() => {
    if (modal_backdrop) {
      setmodal_backdrop(false);
    } else {
      setmodal_backdrop(true);
    }
    setWorkReportDataOne(null)
  }, [modal_backdrop]);

  const columns = useMemo(
    () => [
      {
        header: '№',
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
      },

      {
        header: "Ажлын төрөл",
        accessorKey: "name_work_type",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Судалгааны ажлын нэр',
        accessorKey: "work_name",
        enableColumnFilter: false,
        enableSorting: true,
      },

      {
        header: 'Захиалагч байгууллага',
        accessorKey: "a_organization_name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Гүйцэтгэгч байгууллага',
        accessorKey: "b_organization_name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Фондын бүртгэлийн дугаар',
        accessorKey: "work_number",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Төсөв/сая.төг/',
        accessorKey: numberWithCommas("work_budget"),
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Огноо',
        accessorKey: "date",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Үйлдэл',
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps: any) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li data-bs-toggle="tooltip" data-bs-placement="top" title="View">
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-primary"
                  onClick={(event: any) => {
                    const workReportData = cellProps.row.original;
                    event.preventDefault();
                    handleViewClick(workReportData);
                  }}
                >
                  <i className="mdi mdi-eye-outline" id="viewtooltip"></i>
                  <UncontrolledTooltip placement="top" target="viewtooltip">
                    Харах
                  </UncontrolledTooltip>
                </Link>
              </li>

              <Link
                to="#"
                className="btn btn-sm btn-soft-warning"
                onClick={(event: any) => {
                  const workReportData = cellProps.row.original;
                  event.preventDefault();
                  handleEditClick(workReportData);
                }}
              >
                <i className="mdi mdi-pencil-outline" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Засах
                </UncontrolledTooltip>
              </Link>
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-danger"
                  onClick={(event: any) => {
                    const workReportRowData = cellProps.row.original;
                    event.preventDefault();
                    onClickDelete(workReportRowData);
                  }}
                >
                  <i className="mdi mdi-delete-outline" id="deletetooltip" />
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Delete
                  </UncontrolledTooltip>
                </Link>
              </li>
            </ul>
          );
        }
      },
    ],
    [handleEditClick]
  );
  return (
    <React.Fragment>
      <DeleteModal
        deleteName={workReportDataOne?.workReport_name}
        show={deleteModal}
        onDeleteClick={handleDeleteWorkReport}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Col xl={12}>
        <Card>
          <CardBody className="border-bottom">
            <div className="d-flex align-items-center">
              <img src={miniral} alt="" height="50" />
              <div className="flex-grow-1 ms-3">
                <h5 className="fw-semibold">Мэдээлэл</h5>
                <ul className="list-unstyled hstack gap-2 mb-0">
                  <li>
                    <i className="mdi mdi-table-row-height"></i> <span className="text-muted fw-semibold">Нийт: {numberWithCommas(1644)}</span>
                  </li>
                </ul>
              </div>
              <button
                type="button"
                onClick={() => {
                  handleAddClick();
                }}
                className="btn btn-success  btn-label"
              >
                <i className="mdi mdi-file-plus-outline label-icon"></i> Шинээр нэмэх
              </button>
            </div>
          </CardBody>
          <CardBody>
            {
              isLoading ? <Spinners setLoading={setLoading} />
                :
                <TableContainer
                  columns={columns}
                  data={workReportList || ""}
                  isCustomPageSize={true}
                  isGlobalFilter={true}
                  isPagination={true}
                  colWidth={3}
                  SearchPlaceholder="Судалгааны тайлан хайх . . ."
                  tableClass="align-middle dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                  pagination="pagination"
                  paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                />
            }
          </CardBody>
        </Card>
      </Col>

      <Modal
        size="xl"
        isOpen={modal_backdrop}
        toggle={() => {
          toggle();
        }}

        backdrop={'static'}
        id="staticBackdrop"
        centered
      >
        <ModalHeader toggle={() => {
          toggle();
        }}>
          <div className="h5 modal-title" id="staticBackdropLabel">{!!isEdit ? "Сав газрын тайлан засах" : "Сав газрын тайлан нэмэх"}</div>
        </ModalHeader>
        <ModalBody>
          <Alert color="warning" className="mb-3">
            <strong className="text-danger">(*)</strong> тэмдэг бүхий талбарыг {""}
            <Link to="#" className="alert-link">
              заавал бөглөх
            </Link>  шаардлагатайг анхаарна уу !!!
          </Alert>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <Row>
              <Col lg={6}>
                <div className="mb-3">
                  <Label className="text-danger">Ажлын төрөл</Label>
                  <Input
                    name="cmd_work_type"
                    type="select"
                    onChange={(e) => {
                      validation.handleChange(e);
                      setCmdTypeSelected(e.target.value);
                    }}
                    onBlur={validation.handleBlur}
                    value={
                      validation.values.cmd_work_type || ""
                    }
                    invalid={
                      validation.touched.cmd_work_type && validation.errors.cmd_work_type ? true : false
                    }

                  >
                    <option disabled value="">Сонгох</option>
                    {cmd_work_type?.data?.map((item, index) => (
                      <option value={item?.id}>{item?.name}</option>
                    ))}

                  </Input>
                  {validation.touched.cmd_work_type && validation.errors.cmd_work_type ? (
                    <FormFeedback type="invalid">
                      {validation.errors.cmd_work_type}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label>Судалгааны ажлын нэр</Label>
                  <Input
                    name="work_name"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.work_name || ""}
                    invalid={
                      validation.touched.work_name &&
                        validation.errors.work_name
                        ? true
                        : false
                    }
                  />
                  {validation.touched.work_name &&
                    validation.errors.work_name ? (
                    <FormFeedback type="invalid">
                      {validation.errors.work_name}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label>Захиалагч байгууллага</Label>
                  <Input
                    name="a_organization_id"
                    type="select"
                    onChange={(e) => {
                      validation.handleChange(e);
                      setOrgASelected(e.target.value);
                    }}
                    onBlur={validation.handleBlur}
                    value={
                      validation.values.a_organization_id || ""
                    }
                    invalid={
                      validation.touched.a_organization_id && validation.errors.a_organization_id ? true : false
                    }

                  >
                    <option disabled value="">Сонгох</option>
                    {orgaAId?.data?.map((item, index) => (
                      <option value={item?.organization_id}>{item?.name}</option>
                    ))}

                  </Input>
                  {validation.touched.a_organization_id &&
                    validation.errors.a_organization_id ? (
                    <FormFeedback type="invalid">
                      {validation.errors.a_organization_id}
                    </FormFeedback>
                  ) : null}
                </div>


                <div className="mb-3">
                  <Label>Гүйцэтгэгч байгууллага</Label>
                  <Input
                    name="b_organization_id"
                    type="select"
                    onChange={(e) => {
                      validation.handleChange(e);
                      setOrgBSelected(e.target.value);
                    }}
                    onBlur={validation.handleBlur}
                    value={
                      validation.values.b_organization_id || ""
                    }
                    invalid={
                      validation.touched.b_organization_id && validation.errors.b_organization_id ? true : false
                    }

                  >
                    <option disabled value="">Сонгох</option>
                    {orgaBId?.data?.map((item, index) => (
                      <option value={item?.organization_id}>{item?.name}</option>
                    ))}

                  </Input>
                  {validation.touched.b_organization_id &&
                    validation.errors.b_organization_id ? (
                    <FormFeedback type="invalid">
                      {validation.errors.b_organization_id}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <Label>Фондын бүртгэлийн дугаар
                  </Label>
                  <Input
                    name="work_number"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.work_number || ""}
                    invalid={
                      validation.touched.work_number &&
                        validation.errors.work_number
                        ? true
                        : false
                    }
                  />
                  {validation.touched.work_number &&
                    validation.errors.work_number ? (
                    <FormFeedback type="invalid">
                      {validation.errors.work_number}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label>Төсөв /сая.төг/
                  </Label>
                  <Input
                    name="work_budget"
                    type="text"
                    onChange={(e) => {
                      const rawValue = e.target.value.replace(/,/g, '');
                      validation.setFieldValue('work_budget', rawValue);
                    }}
                    onBlur={validation.handleBlur}
                    value={numberWithCommas(validation.values.work_budget) || ""}
                    invalid={
                      validation.touched.work_budget &&
                        validation.errors.work_budget
                        ? true
                        : false
                    }
                  />
                  {validation.touched.work_budget &&
                    validation.errors.work_budget ? (
                    <FormFeedback type="invalid">
                      {validation.errors.work_budget}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label>Огноо</Label>
                  <Flatpickr
                    className="form-control d-block"
                    placeholder="Огноо"
                    name="date"
                    value={validation.values.date}
                    onChange={(selectDate: Date[]) => {
                      if (selectDate[0]) {
                        const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                          .toISOString()
                          .split('T')[0];
                        validation.setFieldValue('date', localDate);
                      }
                    }}
                    options={{
                      altInput: true,
                      altFormat: "Y-m-d",
                      dateFormat: "Y-m-d",
                      enableTime: false,
                    }}
                  />
                  {validation.touched.date &&
                    validation.errors.date ? (
                    <FormFeedback type="invalid">
                      {validation.errors.date}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>

            </Row>

            {isEdit && (
              <Col lg={5}>
                <CardTitle>Холбогдох зурагнууд</CardTitle>
                <div className="zoom-gallery d-flex gap-3 flex-row flex-wrap justify-content-center">
                  {imageZoom.map((img, index) => (
                    <img
                      key={index}
                      src={img}
                      className="float-left"
                      onClick={() => {
                        setisGalleryZoom(true);
                        setphotoIndex(index);
                      }}
                      width="275"
                    />
                  ))}
                </div>
                {isGalleryZoom && (
                  <Lightbox
                    mainSrc={imageZoom[photoIndex]}
                    nextSrc={imageZoom[(photoIndex + 1) % imageZoom.length]}
                    prevSrc={imageZoom[(photoIndex + imageZoom.length - 1) % imageZoom.length]}
                    onCloseRequest={() => setisGalleryZoom(false)}
                    onMovePrevRequest={() => setphotoIndex((photoIndex + imageZoom.length - 1) % imageZoom.length)}
                    onMoveNextRequest={() => setphotoIndex((photoIndex + 1) % imageZoom.length)}
                  />
                )}
                <CardTitle className="mt-3">Холбогдох PDF файлууд</CardTitle>
                <div className="mb-3">
                  {
                    documentList
                      ?.filter((item) => item?.type_name === "pdf")
                      ?.map((item, index) => (
                        <Link
                          key={index}
                          to={item?.fileUrl}
                          target="__blank"
                          className="btn btn-danger me-2 btn-label"
                        >
                          <i className="mdi mdi-file-pdf-outline label-icon"></i>
                          Файл-{index + 1}
                        </Link>
                      ))
                  }
                </div>

                <CardTitle className="mt-3">Холбогдох WORD файлууд</CardTitle>
                <div className="mb-3">
                  {
                    documentList
                      ?.filter((item) => item?.type_name === "word")
                      ?.map((item, index) => (
                        <Link
                          key={index}
                          to={item?.fileUrl}
                          target="__blank"
                          className="btn btn-success me-2 btn-label"
                        >
                          <i className="mdi mdi-microsoft-excel label-icon"></i>
                          Файл-{index + 1}
                        </Link>
                      ))
                  }
                </div>
              </Col>
            )

            }

            <div className="modal-footer">
              {/* <button type="button" className="btn btn-light" onClick={() => {
                setmodal_backdrop(false);
              }}>Хаах</button> */}
              <button type="submit" className="btn btn-primary">Мэдээлэл хадгалах</button>
            </div>
          </Form>
          {isEdit &&
            <DocumentsUpload
              table_name={'work_report'}
              connection_id={workReportDataOne?.id}
              value_group={'core'}
            />
          }
          <div className="modal-footer">
            <button type="button" className="btn btn-light" onClick={() => {
              setmodal_backdrop(false);
            }}>Хаах</button>
            {/* <button type="submit" className="btn btn-primary">Мэдээлэл хадгалах</button> */}
          </div>
        </ModalBody>

      </Modal>

      <Modal
        size="xl"
        isOpen={workReportModalViewBackdrop}
        toggle={() => {
          workReportModal_backdrop();
        }}
        // backdrop={'static'}
        id="staticBackdrop"
        centered
      >
        <ModalHeader toggle={() => {
          workReportModal_backdrop();
        }}>
          <div className='h5 modal-title' id="staticBackdropLabel">Сав газрын судалгааны тайлан</div>
        </ModalHeader>
        <Form onSubmit={(e) => {
          e.preventDefault();
          validation.handleSubmit();
          return false;
        }}>
          <ModalBody>
            <Row>
              <Col lg={6}>
                <div className="mb-3">
                  <Label>Ажлын төрөл </Label>
                  <Input
                    name="cmd_work_type"
                    type="text"
                    disabled
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={workReportDataOne?.name_work_type}
                  />
                </div>
                <div className="mb-3">
                  <Label>Судалгааны ажлын нэр </Label>
                  <Input
                    name="work_name"
                    type="text"
                    disabled
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={workReportDataOne?.work_name}
                  />
                </div>
                <div className="mb-3">
                  <Label>Захиалагч байгууллага</Label>
                  <Input
                    name="a_organization_name"
                    type="text"
                    disabled
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={workReportDataOne?.a_organization_name}
                  />
                </div>
                <div className="mb-3">
                  <Label>Гүйцэтгэгч байгууллага </Label>
                  <Input
                    name="b_organization_name"
                    type="text"
                    disabled
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={workReportDataOne?.b_organization_name}
                  />
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <Label>Фондын бүртгэлийн дугаар </Label>
                  <Input
                    name="work_number"
                    type="text"
                    disabled
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={workReportDataOne?.work_number}
                  />
                </div>

                <div className="mb-3">
                  <Label>Төсөв /сая.төг/ </Label>
                  <Input
                    name="work_budget"
                    type="text"
                    disabled
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={numberWithCommas(workReportDataOne?.work_budget)}
                  />
                </div>

                <div className="mb-3">
                  <Label>Огноо </Label>

                  <Flatpickr
                    className="form-control d-block"
                    placeholder="Огноо"
                    name="date"
                    disabled
                    value={workReportDataOne?.date}
                    onChange={(selectDate: Date[]) => {
                      if (selectDate[0]) {
                        const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                          .toISOString()
                          .split('T')[0];
                        validation.setFieldValue('date', localDate);
                      }
                    }}
                    options={{
                      altInput: true,
                      altFormat: "Y-m-d",
                      dateFormat: "Y-m-d",
                      enableTime: false,
                    }}
                  />
                </div>

              </Col>
            </Row>
          </ModalBody>
        </Form>
        <Col lg={5}>
          <CardTitle>Холбогдох зурагнууд</CardTitle>
          <div className="zoom-gallery d-flex gap-3 flex-row flex-wrap justify-content-center">
            {imageZoom.map((img, index) => (
              <img
                key={index}
                src={img}
                className="float-left"
                onClick={() => {
                  setisGalleryZoom(true);
                  setphotoIndex(index);
                }}
                width="275"
              />
            ))}
          </div>
          {isGalleryZoom && (
            <Lightbox
              mainSrc={imageZoom[photoIndex]}
              nextSrc={imageZoom[(photoIndex + 1) % imageZoom.length]}
              prevSrc={imageZoom[(photoIndex + imageZoom.length - 1) % imageZoom.length]}
              onCloseRequest={() => setisGalleryZoom(false)}
              onMovePrevRequest={() => setphotoIndex((photoIndex + imageZoom.length - 1) % imageZoom.length)}
              onMoveNextRequest={() => setphotoIndex((photoIndex + 1) % imageZoom.length)}
            />
          )}
          <CardTitle className="mt-3">Холбогдох PDF файлууд</CardTitle>
          <div className="mb-3">
            {
              documentList
                ?.filter((item) => item?.type_name === "pdf")
                ?.map((item, index) => (
                  <Link
                    key={index}
                    to={item?.fileUrl}
                    target="__blank"
                    className="btn btn-danger me-2 btn-label"
                  >
                    <i className="mdi mdi-file-pdf-outline label-icon"></i>
                    Файл-{index + 1}
                  </Link>
                ))
            }
          </div>

          <CardTitle className="mt-3">Холбогдох WORD файлууд</CardTitle>
          <div className="mb-3">
            {
              documentList
                ?.filter((item) => item?.type_name === "word")
                ?.map((item, index) => (
                  <Link
                    key={index}
                    to={item?.fileUrl}
                    target="__blank"
                    className="btn btn-success me-2 btn-label"
                  >
                    <i className="mdi mdi-microsoft-excel label-icon"></i>
                    Файл-{index + 1}
                  </Link>
                ))
            }
          </div>
        </Col>


      </Modal>
    </React.Fragment>
  );
}

export default Detail;